/* eslint-disable jsx-a11y/anchor-has-content */

import React, { Fragment, useCallback } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import classnames from "classnames";

import { stripTrailingSlash } from "../../helpers/strings.helper";
import { useIntlTranslate } from "../../hooks";
import { Icon } from "../icon/Icon";

export const useOpenHelp = (section) => {
  const { url, isExternal } = useSelector((state) => state.config.helpPageLink);

  const helpLink = isExternal || _.isNil(section) ? url : `${url}/${section}`;

  // in demo.d the link will break without including `pathname` because full url of the
  // demo.d page looks like: {protocol}//{hostname}:{port}/secure-business/{segmentWithHash}
  const targetUrl = isExternal
    ? url
    : stripTrailingSlash(window.location.pathname) + helpLink;

  const action = useCallback(() => {
    window.open(targetUrl, "_blank", "noopener noreferrer");
  }, [targetUrl]);

  return [action, targetUrl];
};

export const HelpLink = ({
  section,
  sectionTranslation = "",
  children,
  className = null,
  hasIcon = true,
  ...attrs
}) => {
  const translate = useIntlTranslate();
  const styles = classnames("link--with-icon", className);
  const [openHelp, url] = useOpenHelp(section);

  return (
    <a
      {...attrs}
      className={styles}
      href={url}
      rel="noopener noreferrer"
      target="_blank"
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
        openHelp();
      }}
      aria-label={
        section
          ? translate("aria_see_more_information_on_help", {
              key: sectionTranslation || section,
            })
          : translate("aria_see_more_on_help")
      }
    >
      {hasIcon ? (
        <Fragment>
          <span>{children}</span>
          <Icon icon="fa-regular fa-external-link-square-alt" />
        </Fragment>
      ) : (
        children
      )}
    </a>
  );
};
